<template>
  <div id="userList">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/user-admin` }">User Admin</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/user-admin/${$route.params.id}` }">{{ $route.params.id }} </el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="initializing"></hia-loading>
    <div v-if="!initializing" v-loading="loading" element-loading-spinner="nucleus-loader" class="top-margin">
      <el-form size="mini" label-position="left" label-width="200px">
        <el-row :gutter="20">
          <el-button v-if="isNew" :disabled="auth0FormConfirm || userAccessMessage" @click="createNewUser" type="primary" style="position:absolute; top: 0px; right: 15px; z-index: 1;"><i class="mdi mdi-account-multiple-plus coderIcon"></i>Create User </el-button>
          <el-col :span="12">
            <h4 class="heading">User Profile</h4>
            <el-form-item label="Name">
              <el-input v-model="name" size="mini" type="text" @change.native="putContact(contact)"></el-input>
            </el-form-item>
            <el-form-item label="Title">
              <el-input v-model="title" size="mini" type="text" @change.native="putContact(contact)"></el-input>
            </el-form-item>
            <el-form-item label="Email Address">
              <el-row v-if="!isNew">
                <el-col :span="22">
                  <el-input disabled v-model="contact.emailAddress" size="mini" type="text" id="emailAddress"> </el-input>
                </el-col>
                <el-col :span="2">
                  <el-button
                    title="Update Email Address"
                    style="border-top-left-radius: 0px !important;
                  border-bottom-left-radius: 0px !important;"
                    icon="el-icon-edit"
                    size="mini"
                    @click="updateAuth0UserModal(contact)"
                  ></el-button>
                </el-col>
              </el-row>
              <el-row v-else>
                <el-col :span="24">
                  <el-input v-model="newUserEmail" size="mini" type="text" v-on:keyup.native="newUserValidate()"> </el-input>
                  <span
                    ><small style="color: #F56C6C; position: absolute; bottom: -22px; left: 0px;">{{ invalidEmailAddressMessage }}</small></span
                  >
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="!isNew" label="Nucleus Invite/PW Reset Sent">
              <el-input disabled v-model="nucleusInvitationSentComputed" size="mini" type="text" id="invite"></el-input>
            </el-form-item>
            <el-form-item v-if="!isNew" label="Nucleus Last Login">
              <el-input disabled v-model="nucleusLastLoginComputed" size="mini" type="text" id="lastLogin"></el-input>
            </el-form-item>

            <el-form-item label="Phone Number">
              <el-input v-model="phoneNumberFormatted" size="mini" type="text" @change.native="putContact(contact)"> </el-input>
            </el-form-item>

            <el-form-item label="Notes">
              <el-input type="textarea" v-model="notes" size="mini" rows="3" @change="putContact(contact)"></el-input>
            </el-form-item>
            <el-row v-if="!isNew">
              <h4 class="heading">User Actions</h4>
              <el-form-item label="Inactive">
                <template slot="label">
                  <el-tooltip :content="userActiveTooltip" placement="bottom" effect="light">
                    <span class="dottedUnderline">Active </span>
                  </el-tooltip>
                </template>
                <el-switch :title="activeComputed" v-model="activeComputed" active-color="#13ce66" @change="putContact(contact)" inactive-color="#ff4949"> </el-switch>
              </el-form-item>
              <el-form-item>
                <template slot="label">
                  <span>{{ contact.nucleusLastLogin ? 'PW Reset Email' : 'Invitation Email' }} </span>
                </template>
                <el-button icon="el-icon-message" :disabled="loading" @click="pwResetEmail(contact)">Send Email </el-button>
              </el-form-item>

              <el-form-item label="PW Reset Link" v-if="ITUser()">
                <el-button icon="el-icon-link" :disabled="loading" @click="getPWTicket()">
                  Get Link
                </el-button>
                <div v-loading="pwTicketLoader">
                  <el-input v-if="contact.pwResetTicket" disabled v-model="contact.pwResetTicket" size="mini" type="text" id="pwResetTicket"></el-input>
                </div>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <h4 class="heading">Facility Access</h4>
              <el-alert v-if="userAccessMessage" type="warning" style="float: left; margin-bottom: 20px; font-size: 14px !important;" :closable="false">
                A User must have at least 1 Facility Access role.
              </el-alert>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-button @click="massUpdateModal()" icon="el-icon-connection" class="pull-right">Mass Update </el-button>
                  <div style="float: right; margin: 0px 20px 0px 0px;">
                    <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
                  </div>
                </el-col>
              </el-row>
              <el-col :span="24">
                <el-table ref="facilityList" id="facilityList" :data="filteredFacilityList" max-height="420px" row-key="clientId" stripe>
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <el-row v-if="userAdmin() || documentManagerAdmin()" :gutter="20" style="margin-top: -20px;">
                        <el-col :span="12">
                          <h4 class="heading">Nucleus Access</h4>
                          <el-form-item>
                            <template slot="label">
                              <el-tooltip popper-class="nucleusTooltip" :content="`${nucleusUserTooltip} ${isNew ? nucleusUserTooltipNew : ''}`" placement="bottom" effect="light"> <span class="dottedUnderline">Nucleus User </span></el-tooltip>
                            </template>
                            <el-switch active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 8))" v-model="scope.row.contactRoles.find(f => f.roleId === 8).active" inactive-color="#ff4949"> </el-switch>
                          </el-form-item>
                          <div class="nucleusAccessChildren">
                            <el-form-item>
                              <template slot="label">
                                <el-tooltip popper-class="nucleusTooltip" :content="codingDashboardTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Dashboard</span></el-tooltip>
                              </template>
                              <el-switch :disabled="!scope.row.contactRoles.find(f => f.roleId === 8).active" active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 11))" v-model="scope.row.contactRoles.find(f => f.roleId === 11).active" inactive-color="#ff4949"> </el-switch>
                            </el-form-item>
                            <el-form-item>
                              <template slot="label">
                                <el-tooltip popper-class="nucleusTooltip" :content="reviewDashboardTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Review Dashboard</span></el-tooltip>
                              </template>
                              <el-switch :disabled="!scope.row.contactRoles.find(f => f.roleId === 8).active" active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 12))" v-model="scope.row.contactRoles.find(f => f.roleId === 12).active" inactive-color="#ff4949"> </el-switch>
                            </el-form-item>
                            <el-form-item>
                              <template slot="label">
                                <el-tooltip popper-class="nucleusTooltip" :content="nucleusUserAdminTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Nucleus User Admin</span></el-tooltip>
                              </template>
                              <el-switch :disabled="!scope.row.contactRoles.find(f => f.roleId === 8).active" active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 13))" v-model="scope.row.contactRoles.find(f => f.roleId === 13).active" inactive-color="#ff4949"> </el-switch>
                            </el-form-item>

                            <el-form-item>
                              <template slot="label">
                                <el-tooltip popper-class="nucleusTooltip" :content="codingQuestionsTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Questions</span></el-tooltip>
                              </template>
                              <el-switch :disabled="!scope.row.contactRoles.find(f => f.roleId === 8).active" active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 24))" v-model="scope.row.contactRoles.find(f => f.roleId === 24).active" inactive-color="#ff4949"> </el-switch>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <h4 class="heading">Operational Report Access</h4>
                          <el-form-item v-if="ITUser()" label="General Contact">
                            <el-switch active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 9))" v-model="scope.row.contactRoles.find(f => f.roleId === 9).active" inactive-color="#ff4949"> </el-switch>
                          </el-form-item>
                          <el-form-item>
                            <template slot="label">
                              <el-tooltip popper-class="nucleusTooltip" :content="codingLogsTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Logs</span></el-tooltip>
                            </template>
                            <el-switch active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 3))" v-model="scope.row.contactRoles.find(f => f.roleId === 3).active" inactive-color="#ff4949"> </el-switch>
                          </el-form-item>
                          <el-form-item>
                            <template slot="label">
                              <el-tooltip popper-class="nucleusTooltip" :content="codingScheduleTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Schedule</span></el-tooltip>
                            </template>
                            <el-switch active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 4))" v-model="scope.row.contactRoles.find(f => f.roleId === 4).active" inactive-color="#ff4949"> </el-switch>
                          </el-form-item>
                          <el-form-item>
                            <template slot="label">
                              <el-tooltip popper-class="nucleusTooltip" :content="reviewScheduleTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Review Schedule</span></el-tooltip>
                            </template>
                            <el-switch active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 5))" v-model="scope.row.contactRoles.find(f => f.roleId === 5).active" inactive-color="#ff4949"> </el-switch>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row v-if="rebuttalManager() || documentManagerAdmin()" :gutter="20" style="margin-top: -10px;">
                        <h4 class="heading">Rebuttal Access</h4>
                        <el-form-item>
                          <template slot="label">
                            <el-tooltip popper-class="nucleusTooltip" :content="rebuttalUserTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Rebuttal User</span></el-tooltip>
                          </template>
                          <el-switch active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 21))" v-model="scope.row.contactRoles.find(f => f.roleId === 21).active" inactive-color="#ff4949"> </el-switch>
                        </el-form-item>
                        <el-form-item>
                          <template slot="label">
                            <el-tooltip popper-class="nucleusTooltip" :content="rebuttalManagerTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Rebuttal Manager</span></el-tooltip>
                          </template>
                          <el-switch active-color="#13ce66" @change="putContactRoles(scope, scope.row.contactRoles.find(f => f.roleId === 22))" v-model="scope.row.contactRoles.find(f => f.roleId === 22).active" inactive-color="#ff4949"> </el-switch>
                        </el-form-item>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column prop="clientName" label="Client Name" sortable> </el-table-column>
                  <el-table-column label="Access" :sortable="true" :sort-method="boolSortComparer('access')">
                    <template slot-scope="scope">
                      <div v-if="scope.row.contactRoles.find(f => f.active === true)">
                        <el-tag size="mini" type="success" :title="displayContactRoles(scope)"
                          >Granted
                          {{ scope.row.contactRoles.filter(f => f.active === true && f.roleId !== 9).length ? `+${scope.row.contactRoles.filter(f => f.active === true && f.roleId !== 9).length}` : `` }}
                        </el-tag>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="!initializing" id="dialogs">
      <el-dialog v-loading="loading" title="Update Email Address" :visible.sync="showUpdateAuth0User" width="30%" :show-close="false" :close-on-click-modal="false">
        <el-form :model="auth0Form" ref="auth0Form" :rules="auth0Form.rules" size="mini" label-position="top" label-width="180px" :show-message="false">
          <el-form-item label="New Email Address" prop="emailAddress">
            <el-col :span="24">
              <el-input v-model="auth0Form.emailAddress" size="mini" type="text" v-on:keyup.native="updateAuth0FormValidate()"> </el-input>
              <span
                ><small style="color: #F56C6C; position: absolute; bottom: -30px; left: 0px;">{{ invalidEmailAddressMessage }}</small></span
              >
            </el-col>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              showUpdateAuth0User = false
              auth0Form.emailAddress = ''
              invalidEmailAddressMessage = ''
              auth0Form.domain = ''
            "
          >
            Cancel</el-button
          >
          <el-button :disabled="auth0FormConfirm" type="primary" @click="putAuth0User(contact)">Confirm </el-button>
        </span>
      </el-dialog>
      <el-dialog v-loading="loading" title="Mass Update" :visible.sync="massUpdate" width="40%" :show-close="false" :close-on-click-modal="false">
        <el-row>
          <el-col :span="24">
            <p>Clone User Access to muliple facilities.</p>
            <el-select style="width: 100%;" size="mini" :default-first-option="true" class="hia-multiple" v-model="facilityMultiSelect" clearable multiple placeholder="Facilities" @change="handleSelectChange" :collapse-tags="true">
              <el-option value="selectAll" label="Select All"></el-option>
              <el-option v-for="item in userAdminClients" :key="item.clientId" :label="item.clientName" :value="item.clientNumber"> </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row v-if="userAdmin() || documentManagerAdmin()" :gutter="20" style="margin-top: -20px;">
          <el-form size="mini" label-position="left" label-width="200px" id="massUpdateTemplate">
            <el-col :span="12">
              <h4 class="heading">Nucleus Access</h4>
              <el-form-item>
                <template slot="label">
                  <el-tooltip popper-class="nucleusTooltip" :content="`${nucleusUserTooltip} ${isNew ? nucleusUserTooltipNew : ''}`" placement="bottom" effect="light"> <span class="dottedUnderline">Nucleus User</span></el-tooltip>
                </template>
                <el-switch v-model="massUpdateAccessList.find(f => f.roleId === 8).active" active-color="#13ce66" inactive-color="#ff4949" @change="massUpdateNucleusUserCheck"> </el-switch>
              </el-form-item>
              <div class="nucleusAccessChildren">
                <el-form-item>
                  <template slot="label">
                    <el-tooltip popper-class="nucleusTooltip" :content="codingDashboardTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Dashboard</span></el-tooltip>
                  </template>
                  <el-switch :disabled="!massUpdateAccessList.find(f => f.roleId === 8).active" v-model="massUpdateAccessList.find(f => f.roleId === 11).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                </el-form-item>

                <el-form-item>
                  <template slot="label">
                    <el-tooltip popper-class="nucleusTooltip" :content="reviewDashboardTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Review Dashboard</span></el-tooltip>
                  </template>
                  <el-switch :disabled="!massUpdateAccessList.find(f => f.roleId === 8).active" v-model="massUpdateAccessList.find(f => f.roleId === 12).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                </el-form-item>

                <el-form-item>
                  <template slot="label">
                    <el-tooltip popper-class="nucleusTooltip" :content="nucleusUserAdminTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Nucleus User Admin</span></el-tooltip>
                  </template>

                  <el-switch :disabled="!massUpdateAccessList.find(f => f.roleId === 8).active" v-model="massUpdateAccessList.find(f => f.roleId === 13).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                </el-form-item>

                <el-form-item>
                  <template slot="label">
                    <el-tooltip popper-class="nucleusTooltip" :content="codingQuestionsTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Questions</span></el-tooltip>
                  </template>

                  <el-switch :disabled="!massUpdateAccessList.find(f => f.roleId === 8).active" v-model="massUpdateAccessList.find(f => f.roleId === 24).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <h4 class="heading">Operational Access</h4>
              <el-form-item v-if="ITUser()" label="General Contact">
                <el-switch active-color="#13ce66" v-model="massUpdateAccessList.find(f => f.roleId === 9).active" inactive-color="#ff4949"> </el-switch>
              </el-form-item>

              <el-form-item>
                <template slot="label">
                  <el-tooltip popper-class="nucleusTooltip" :content="codingLogsTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Logs</span></el-tooltip>
                </template>
                <el-switch v-model="massUpdateAccessList.find(f => f.roleId === 3).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
              </el-form-item>

              <el-form-item>
                <template slot="label">
                  <el-tooltip popper-class="nucleusTooltip" :content="codingScheduleTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Coding Schedule</span></el-tooltip>
                </template>
                <el-switch v-model="massUpdateAccessList.find(f => f.roleId === 4).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
              </el-form-item>

              <el-form-item label="Review Schedule">
                <template slot="label">
                  <el-tooltip popper-class="nucleusTooltip" :content="reviewScheduleTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Review Schedule</span></el-tooltip>
                </template>
                <el-switch v-model="massUpdateAccessList.find(f => f.roleId === 5).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <el-row v-if="documentManagerAdmin() || rebuttalManager()" :gutter="20" style="margin-top: 20px; margin-right: 0px !important; margin-left: 0px !important;">
          <el-form size="mini" label-position="left" label-width="200px" id="massUpdateTemplate">
            <h4 class="heading">Rebuttal Access</h4>
            <el-form-item>
              <template slot="label">
                <el-tooltip popper-class="nucleusTooltip" :content="rebuttalUserTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Rebuttal User</span></el-tooltip>
              </template>
              <el-switch v-model="massUpdateAccessList.find(f => f.roleId === 21).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-form-item>

            <el-form-item>
              <template slot="label">
                <el-tooltip popper-class="nucleusTooltip" :content="rebuttalManagerTooltip" placement="bottom" effect="light"> <span class="dottedUnderline">Rebuttal Manager</span></el-tooltip>
              </template>
              <el-switch v-model="massUpdateAccessList.find(f => f.roleId === 22).active" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-form-item>
          </el-form>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="massUpdateClosed()"> Cancel</el-button>
          <el-button :disabled="!facilityMultiSelect.length || !massUpdateAccessList.some(f => f.active === true)" type="primary" @click="massUpdateUser()">Confirm </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapState, mapActions, mapMutations } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import hiaFilters from '@/mixins/hiaFilters'
import { createHelpers } from 'vuex-map-fields'
import { formatNumber } from 'libphonenumber-js'
import { validateAndMaybeAddEmailDomain } from '@/utilities/emailDomainValidation'

const { mapFields } = createHelpers({
  getterType: 'userAdmin/getField',
  mutationType: 'userAdmin/updateField'
})

export default {
  data: function() {
    return {
      loading: false,
      initializing: true,
      pwTicketLoader: false,
      showUpdateAuth0User: false,
      auth0FormConfirm: true,
      userActiveTooltip: "Grants or disables user's access to Nucleus",
      nucleusUserTooltip: 'Required base role for Nucleus access. Grants Document Manager and the Coding, Review, and Interim Request forms.',
      nucleusUserTooltipNew: 'New users will automatically receive a Nucleus Invitation email.',
      codingDashboardTooltip: 'Grants access to the Coding Dashboard, including productivity, schedules, and coding logs reports.',
      reviewDashboardTooltip: 'Grants access to the Review Dashboard with inpatient, outpatient, pro fee, and ambulatory review analytics.',
      nucleusUserAdminTooltip: 'Lets the user create and manage other users in Nucleus for your facility.',
      codingQuestionsTooltip: 'Lets the user submit and respond to Coding Questions in Nucleus.',
      codingLogsTooltip: 'Receives daily Coding Logs emails from HIA. Does not grant Nucleus access on its own.',
      codingScheduleTooltip: 'Receives Coding Schedule emails and is copied on Coding Schedule Requests submitted in Nucleus.',
      reviewScheduleTooltip: 'Receives Review Schedule emails and is copied on Review and Interim Services Requests submitted in Nucleus.',
      rebuttalUserTooltip: 'For coders. Grants access to My Projects to respond to their own review findings.',
      rebuttalManagerTooltip: 'Manages the rebuttal process for your facility. Grants My Projects, Rebuttal Tracking, and the ability to manage Rebuttal Users.',
      auth0Form: {
        emailAddress: '',
        domain: '',
        rules: {
          emailAddress: [{ required: true, trigger: 'change', type: 'email' }]
        }
      },
      invalidEmailAddressMessage: '',
      newContactRole: {
        clientNumber: null,
        contactId: null,
        currentClient: null,
        role: null,
        roleId: null,
        active: false
      },
      newUserEmail: '',
      newUserDomain: '',
      userAccessMessage: false,
      showOtherFacilityAccess: false,
      deleteContactRoles: [],
      filterCriteria: '',
      currentPage: 1,
      itemsPerPage: 10,
      massUpdate: false,
      facilityMultiSelect: [],
      massUpdateAccessList: []
    }
  },
  mixins: [HiaAuthorization, hiaFilters],
  name: 'UserAdmin',
  components: {},
  methods: {
    ...mapActions('userAdmin/', ['GET_CONTACTS', 'GET_CONTACT', 'PUT_CONTACT', 'GET_PW_RESET_TICKET', 'POST_PW_RESET_EMAIL', 'GET_CONTACTROLES', 'POST_CONTACT_ROLE', 'DELETE_CONTACT_ROLE_MULTIPLE', 'POST_CONTACT', 'POST_CONTACT_ROLE_MULTIPLE', 'POST_MASSUPDATE_CONTACT_ROLE_MULTIPLE']),
    ...mapMutations('userAdmin/', ['PUSH_CONTACT_ROLE', 'SPLICE_CONTACT_ROLE', 'SET_CONTACT', 'SPLICE_NEW_CONTACT_ROLE', 'SET_MASSUPDATE_CONTACTROLES']),
    initialize() {
      // user admin check
      if (!this.userAdmin() && !this.rebuttalManager()) {
        this.$router.push('/')
        return
      }

      this.initializing = true
      if (!this.isNew) {
        Promise.all([this.GET_CONTACT(this.$route.params.id), this.GET_CONTACTROLES()]).then(response => {
          this.initializing = false
          // build massupdate list
          this.massUpdateAccessList = this.buildContactRoles('')
        })
      } else {
        this.userAccessMessage = true
        Promise.all([this.GET_CONTACTROLES()]).then(response => {
          this.initializing = false
          // build massupdate list
          this.massUpdateAccessList = this.buildContactRoles('')
        })

        this.SET_CONTACT({
          auth0UserId: null,
          cellNumber: null,
          contactRoles: [],
          emailAddress: null,
          hiaTitle: null,
          inactive: false,
          name: null,
          notes: null,
          nucleusInvitationSent: null,
          nucleusLastLogin: null,
          phoneNumber: null,
          sendInvitation: false,
          title: null
        })
      }
    },
    async createNewUser() {
      // set email domain
      this.contact.emailAddress = `${this.newUserEmail}${this.newUserDomain}`
      this.loading = true
      try {
        // IT/super users can assign roles across many facilities while routed under one client
        const roleClientNumbers = (this.contact.contactRoles || []).map(r => r.clientNumber).filter(Boolean)
        const ok = await validateAndMaybeAddEmailDomain(
          this.baseApiUrl,
          this.contact.emailAddress,
          this.currentClientId,
          roleClientNumbers
        )
        if (!ok) {
          this.loading = false
          return
        }

        await this.POST_CONTACT(this.contact)
        this.loading = false
        this.$message({
          message: 'Nucleus User Created',
          type: 'success'
        })
        this.$router.push(`/${this.currentClientId}/user-admin/${this.contact.id}`)
      } catch (error) {
        this.$message({
          message: 'Error Creating Nucleus User: ' + ((error.response && error.response.data && error.response.data.message) || error.message),
          type: 'error'
        })
        this.loading = false
        console.log(error)
      }
    },
    putContact(user) {
      if (this.isNew) {
        return
      }
      this.loading = true
      this.PUT_CONTACT(this.contact).then(
        response => {
          this.loading = false
          this.$message({
            message: 'Nucleus User Updated',
            type: 'success'
          })
        },
        error => {
          this.$message({
            message: 'Error Updating Nucleus User',
            type: 'error'
          })
          this.loading = false
          console.log(error)
        }
      )
    },
    pwResetEmail(user) {
      this.loading = true
      this.POST_PW_RESET_EMAIL(user).then(
        response => {
          this.nucleusInvitationSent = response.nucleusInvitationSent
          this.loading = false
          this.$message({
            message: 'Password reset email sent',
            type: 'info'
          })
        },
        error => {
          this.$message({
            message: 'Error Sending Email: ' + error.response.data.message,
            type: 'error'
          })
          this.loading = false
        }
      )
    },
    getPWTicket() {
      this.pwTicketLoader = true
      // call method with contact.auth0UserId
      this.GET_PW_RESET_TICKET(this.contact.auth0UserId).then(response => {
        this.pwTicketLoader = false
      })
    },
    updateAuth0UserModal() {
      this.showUpdateAuth0User = true
    },
    updateAuth0FormValidate() {
      this.$refs['auth0Form'].validate(valid => {
        if (valid && this.auth0Form.emailAddress.length) {
          if (!/[\\/:*?""<>|]/.test(this.auth0Form.emailAddress)) {
            this.invalidEmailAddressMessage = ''
            this.auth0FormConfirm = false
            return true
          } else {
            this.invalidEmailAddressMessage = 'Email Address may not contain any of \\ / : * ? "< > |'
            this.auth0FormConfirm = true
            return false
          }
        } else {
          this.invalidEmailAddressMessage = 'Email Address may not contain any of \\ / : * ? "< > |'
          this.auth0FormConfirm = true
          return false
        }
      })
    },
    newUserValidate() {
      if (this.newUserEmail.length && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.newUserEmail)) {
        if (!/[\\/:*?""<>|]/.test(this.newUserEmail)) {
          this.invalidEmailAddressMessage = ''
          this.auth0FormConfirm = false
          return true
        } else {
          this.invalidEmailAddressMessage = 'Email Address may not contain any of \\ / : * ? "< > |'
          this.auth0FormConfirm = true
          return false
        }
      } else {
        this.invalidEmailAddressMessage = 'Email Address may not contain any of \\ / : * ? "< > |'
        this.auth0FormConfirm = true
        return false
      }
    },
    putAuth0User(contact) {
      let payload = Object.assign({}, this.contact)
      payload.emailAddress = this.auth0Form.emailAddress
      if (!this.contact.emailAddress) {
        payload.sendInvitation = true
      }
      this.loading = true
      this.PUT_CONTACT(payload).then(response => {
        this.loading = false
        this.showUpdateAuth0User = false
        this.$message({
          message: 'Nucleus User Updated',
          type: 'success'
        })
      })
    },
    buildFacilityList() {
      let facilityList = Object.assign([], this.userAdminClients)
      // loop over each client add roles
      if (facilityList.length) {
        for (let i = 0; i < facilityList.length; i++) {
          facilityList[i].contactRoles = this.buildContactRoles(facilityList[i].clientNumber)
          facilityList[i].access = facilityList[i].contactRoles.some(f => f.active === true)
        }
      }

      return facilityList
    },
    buildContactRoles(clientNumber) {
      let contactRoles = []
      // init roles and check for existing roles in contact
      let generalContact = this.addContactRole(clientNumber, 9)
      let nucleusUser = this.addContactRole(clientNumber, 8)
      let codingDashboard = this.addContactRole(clientNumber, 11)
      let reviewDashboard = this.addContactRole(clientNumber, 12)
      let nucleusUserAdmin = this.addContactRole(clientNumber, 13)
      let codingLogs = this.addContactRole(clientNumber, 3)
      let codingSchedule = this.addContactRole(clientNumber, 4)
      let reviewSchedule = this.addContactRole(clientNumber, 5)
      let rebuttalUser = this.addContactRole(clientNumber, 21)
      let rebuttalManager = this.addContactRole(clientNumber, 22)
      let codingQuestions = this.addContactRole(clientNumber, 24)

      contactRoles.push(generalContact, nucleusUser, codingDashboard, reviewDashboard, nucleusUserAdmin, codingLogs, codingSchedule, reviewSchedule, rebuttalUser, rebuttalManager, codingQuestions)

      return contactRoles
    },
    addContactRole(clientNumber, roleId) {
      let contactRole = Object.assign({}, this.newContactRole)
      if (this.contact.contactRoles.some(s => s.clientNumber === clientNumber && s.roleId === roleId)) {
        contactRole = this.contact.contactRoles.find(s => s.clientNumber === clientNumber && s.roleId === roleId)
      } else {
        contactRole.roleId = roleId
        contactRole.clientNumber = clientNumber
        contactRole.contactId = this.contact.id
      }
      return contactRole
    },
    putContactRoles(row, contactRole) {
      // new user
      if (this.isNew) {
        if (contactRole.active) {
          // add contact role and general contact
          delete contactRole.contactId
          delete contactRole.currentClient
          delete contactRole.role
          this.PUSH_CONTACT_ROLE(contactRole)
          this.nucleusUserCheck(row, contactRole)
          this.userAccessMessage = false
          this.newUserValidate()
        } else {
          this.lastFacilityCheck(row, contactRole)
          let index = this.contact.contactRoles.findIndex(x => x === contactRole)
          this.SPLICE_NEW_CONTACT_ROLE(index)
          this.nucleusUserCheck(row, contactRole)
        }
        return
      }
      // add/delete contact role
      if (contactRole.active) {
        this.loading = true
        this.nucleusUserCheck(row, contactRole).then(response => {
          this.$nextTick(() => {
            let activeRoles = row.row.contactRoles.filter(f => f.active === true)
            // activeRoles.push(contactRole)
            this.POST_CONTACT_ROLE_MULTIPLE(activeRoles).then(
              response => {
                this.nucleusInvitationSent = response.nucleusInvitationSent
                this.userAccessMessage = false
                this.loading = false
                this.$message({
                  message: 'Facility Access Updated',
                  type: 'info'
                })
              },
              error => {
                this.$message({
                  message: 'Error Updating Facility Access ',
                  type: 'error'
                })
                this.loading = false
                console.log(error)
              }
            )
          })
        })
      } else {
        // check if at least one facility has a role
        let flag = this.lastFacilityCheck(row, contactRole)
        this.$nextTick(() => {
          if (!flag) {
            this.loading = true
            this.deleteContactRoles = []
            this.deleteContactRoles.push(contactRole)
            this.nucleusUserCheck(row, contactRole).then(response => {
              this.DELETE_CONTACT_ROLE_MULTIPLE(this.deleteContactRoles).then(
                response => {
                  this.deleteContactRoles = []
                  this.nucleusInvitationSent = response.nucleusInvitationSent
                  this.loading = false
                  this.$message({
                    message: 'Facility Access Updated',
                    type: 'info'
                  })
                },
                error => {
                  this.$message({
                    message: 'Error Deleting Facility Access',
                    type: 'error'
                  })
                  this.loading = false
                  console.log(error)
                }
              )
            })
          }
        })
      }
    },
    generalContactCheck(row, contactRole) {
      if (contactRole.active) {
        // add general contact if not there
        if (!row.row.contactRoles.some(s => s.roleId === 9 && s.active === true)) {
          if (this.isNew) {
            this.PUSH_CONTACT_ROLE({ clientNumber: row.row.clientNumber, roleId: 9, active: true, contactId: this.contact.id })
          } else {
            row.row.contactRoles.find(s => s.roleId === 9).active = true
          }
        }
      } else {
        // remove general contact if no other roles active
        let activeContactRoles = row.row.contactRoles.filter(f => f.active)
        if (activeContactRoles.some(s => s.roleId === 9 && s.active === true) && activeContactRoles.length === 1) {
          if (this.isNew) {
            let index = this.contact.contactRoles.findIndex(x => x.roleId === 9 && x.clientNumber === row.row.clientNumber)
            this.SPLICE_NEW_CONTACT_ROLE(index)
          } else {
            let roleToDelete = this.contact.contactRoles.find(x => x.roleId === 9 && x.clientNumber === row.row.clientNumber)
            this.deleteContactRoles.push(roleToDelete)
          }
        }
      }
    },
    nucleusUserCheck(row, contactRole) {
      return new Promise(resolve => {
        // remove nucleus user children if nucleus user is not active
        if (row.row.contactRoles.some(s => s.roleId === 8 && s.active === false)) {
          let nucleusUserChildren = row.row.contactRoles.filter(s => [11, 12, 13, 24].find(n => n === s.roleId) && s.active === true)

          for (let i = 0; i < nucleusUserChildren.length; i++) {
            if (this.isNew) {
              let index = this.contact.contactRoles.findIndex(x => x.roleId === nucleusUserChildren[i].roleId && x.clientNumber === contactRole.clientNumber)
              this.SPLICE_NEW_CONTACT_ROLE(index)
            } else {
              let roleToDelete = this.contact.contactRoles.find(x => x.roleId === nucleusUserChildren[i].roleId && x.clientNumber === contactRole.clientNumber)
              this.deleteContactRoles.push(roleToDelete)
            }
          }
        }

        resolve(true)
      })
    },
    lastFacilityCheck(row, contactRole) {
      let response = false
      this.userAccessMessage = false
      let activeClients = this.facilityList.filter(f => f.contactRoles.some(f => f.active === true))
      // check for nucleus user and children
      if (contactRole.roleId === 8 && contactRole.active === false) {
        let nucleusUserChildren = row.row.contactRoles.filter(s => [11, 12, 13].find(n => n === s.roleId) && s.active === true)
        let operationalRoles = row.row.contactRoles.filter(s => [3, 4, 5, 9].find(n => n === s.roleId) && s.active === true)

        if (nucleusUserChildren.length) {
          if (!operationalRoles.length) {
            contactRole.active = !this.isNew
            this.userAccessMessage = true
            response = true
          }
        }
      }

      if (activeClients.length === 0) {
        contactRole.active = !this.isNew
        this.userAccessMessage = true
        response = true
      }
      return response
    },
    displayContactRoles(scope) {
      let builder = ''
      if (scope.row.contactRoles.length) {
        scope.row.contactRoles
          .filter(f => f.active === true && f.roleId !== 9)
          .forEach((v, i) => {
            let found = this.contactRoles.find(f => f.key === v.roleId)
            if (found) {
              builder += `${found.value} \n`
            }
          })
      }
      return builder
    },
    massUpdateModal() {
      this.massUpdate = !this.massUpdate
    },
    handleSelectChange(val) {
      if (val.toString().includes('selectAll')) {
        this.facilityMultiSelect = this.userAdminClients.map(f => f.clientNumber)
      }
    },
    massUpdateUser() {
      this.$confirm('This will overwrite the current user access. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.runMassUpdateUser()
        })
        .catch(() => {
          console.log('mass updat error')
        })
    },
    runMassUpdateUser() {
      let contactRoles = []
      // loop over and compare; build roles for backend
      for (let i = 0; i < this.facilityMultiSelect.length; i++) {
        this.massUpdateAccessList.forEach((v, y) => {
          let temp = Object.assign({}, v)
          temp.clientNumber = this.facilityMultiSelect[i]
          temp.contactId = this.contact.id
          contactRoles.push(temp)
        })
      }
      if (this.isNew) {
        this.SET_MASSUPDATE_CONTACTROLES(contactRoles.filter(f => f.active === true))
        this.massUpdateClosed()
        this.newUserValidate()
        this.userAccessMessage = false
      } else {
        // update user
        this.loading = true
        let payload = this.ITUser() ? contactRoles : contactRoles.filter(f => f.roleId !== 9)

        this.POST_MASSUPDATE_CONTACT_ROLE_MULTIPLE(payload).then(
          response => {
            this.loading = false
            this.massUpdateClosed()
            this.$message({
              message: 'Mass User Access Updated',
              type: 'info'
            })
          },
          error => {
            this.$message({
              message: 'Error Mass User Access',
              type: 'error'
            })
            this.loading = false
            console.log(error)
          }
        )
      }
    },
    massUpdateNucleusUserCheck(val) {
      this.massUpdateAccessList.forEach((v, i) => {
        if (!val && [11, 12, 13].find(n => n === v.roleId)) {
          v.active = val
        }
      })
    },
    massUpdateClosed() {
      this.facilityMultiSelect = []
      this.massUpdateAccessList = this.buildContactRoles('')
      this.massUpdate = false
    },
    accessSort(a, b) {
      let a1 = a.access ? a.access : false
      let b1 = b.access ? b.access : false
      if (a1 < b1) {
        return 1
      }
      if (a1 > b1) {
        return -1
      }
      return 0
    }
  },
  created: function() {
    this.initialize()
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId', 'clients', 'baseApiUrl']),
    ...mapState('userAdmin/', ['contacts', 'contact', 'contactRoles', 'distinctDomains']),
    ...mapFields(['contact.name', 'contact.title', 'contact.phoneNumber', 'contact.cellNumber', 'contact.inactive', 'contact.hiaTitle', 'contact.notes', 'contact.nucleusInvitationSent', 'contact.pwResetTicket']),
    nucleusInvitationSentComputed() {
      if (!this.contact.nucleusInvitationSent) {
        return null
      }
      return format(parseISO(this.contact.nucleusInvitationSent), 'M/dd/yyyy h:mm a')
    },
    nucleusLastLoginComputed() {
      if (!this.contact.nucleusLastLogin) {
        return null
      }
      return format(parseISO(this.contact.nucleusLastLogin), 'M/dd/yyyy h:mm a')
    },
    phoneNumberFormatted: {
      get: function() {
        if (this.phoneNumber) {
          return formatNumber({ country: 'US', phone: this.phoneNumber }, 'National')
        } else {
          return this.phoneNumber
        }
      },
      set: function(value) {
        this.phoneNumber = value
      }
    },
    activeComputed: {
      // getter
      get: function() {
        return !this.contact.inactive
      },
      // setter
      set: function(newValue) {
        this.contact.inactive = !newValue
      }
    },
    isNew() {
      return this.$route.params.id === 'new'
    },
    facilityList() {
      let list = this.buildFacilityList()
      return list
    },
    filteredFacilityList() {
      if (this.facilityList.length) {
        return this.filterList(this.facilityList, this.filterCriteria, ['clientName', 'clientNumber', 'access'])
      }
      return []
    },
    userAdminClients() {
      let userClients = []
      this.clients.forEach((v, i) => {
        if (this.isUserAdminClient(v.clientNumber)) {
          userClients.push(v)
        }
      })
      // check for hia admin
      if (this.user.email.includes('@hiacode.com')) {
        userClients = this.clients.find(x => x.clientNumber === 'zpawl') ? this.clients : userClients
      }

      return userClients
    }
  }
}
</script>

<style scoped>
/* BUTTON ICONS*/
.linkIcon {
  font-size: 20px;
  float: left;
  height: 12px;
  margin: -3px 5px 0px 0px;
}

.coderIcon {
  font-size: 20px;
  float: left;
  height: 12px;
  margin: -3px 5px 0px 0px;
}

.nucleusAccessChildren >>> .el-form-item__label {
  width: 180px !important;
  margin-left: 20px;
}

#facilityList >>> .caret-wrapper,
#massUpdateTemplate >>> .caret-wrapper {
  display: none;
}

#facilityList >>> .el-form-item__label,
#massUpdateTemplate >>> .el-form-item__label {
  font-size: 12px !important;
}

#facilityList >>> .el-switch__core,
#massUpdateTemplate >>> .el-switch__core {
  height: 14px;
}

#facilityList >>> .el-switch__core:after,
#massUpdateTemplate >>> .el-switch__core:after {
  width: 10px;
  height: 10px;
}

#facilityList >>> .el-switch.is-checked .el-switch__core::after,
#massUpdateTemplate >>> .el-switch.is-checked .el-switch__core::after {
  left: 100%;
  margin-left: -11px;
}
</style>

<style>
.nucleusTooltip {
  width: 250px !important;
}
</style>
